"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.labelOfArrival = exports.arrivalDay = void 0;
__exportStar(require("./countBookingPeople"), exports);
__exportStar(require("./departureCapacityColor"), exports);
__exportStar(require("./isNotFullyDefinedCustomer"), exports);
__exportStar(require("./marketBooking"), exports);
__exportStar(require("./paymentStatus"), exports);
__exportStar(require("./reservationPrice"), exports);
__exportStar(require("./reservationStatus"), exports);
__exportStar(require("./sumPaymentReceipts"), exports);
__exportStar(require("./lastReceipt"), exports);
__exportStar(require("./translatePayment"), exports);
__exportStar(require("./equipments/canoe"), exports);
const arrivalDay = (date, overDays) => {
    if (!overDays || overDays < 2) {
        return date;
    }
    return date.add(overDays - 1, 'day');
};
exports.arrivalDay = arrivalDay;
const NO_ARRIVAL_TIME_LABEL = 'sans horaire';
function labelOfArrival(date) {
    if (!date) {
        return NO_ARRIVAL_TIME_LABEL;
    }
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return `${String(date.getHours()).padStart(2, '0')}h${String(date.getMinutes()).padStart(2, '0')}`;
}
exports.labelOfArrival = labelOfArrival;
//# sourceMappingURL=index.js.map